package com.devsusana.portfolio.pages

import androidx.compose.runtime.Composable
import com.devsusana.portfolio.components.layouts.PageLayout
import com.devsusana.portfolio.components.sections.AgenticJourneySection
import com.devsusana.portfolio.components.sections.BlogSection
import com.devsusana.portfolio.components.sections.ExperienceSection
import com.devsusana.portfolio.components.sections.HeroSection
import com.devsusana.portfolio.components.sections.ProjectsSection
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page

/**
 * Root landing page ("/") showcasing Susana Córdoba's experience, HomeTutorPro,
 * and her agentic programming journey.
 */
@Page
@Composable
fun HomePage() {
    PageLayout(title = "Susana Córdoba | Senior Android Engineer & Tech Lead") {
        Column(modifier = Modifier.fillMaxWidth()) {
            HeroSection()
            ProjectsSection()
            AgenticJourneySection()
            ExperienceSection()
            BlogSection()
        }
    }
}
